// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IClaimsTeamOrganizationDto
 */
export interface IClaimsTeamOrganizationDto {
    /**
     * 
     * @type {number}
     * @memberof IClaimsTeamOrganizationDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IClaimsTeamOrganizationDto
     */
    name?: string;
}

/**
 * Check if a given object implements the IClaimsTeamOrganizationDto interface.
 */
export function instanceOfIClaimsTeamOrganizationDto(value: object): value is IClaimsTeamOrganizationDto {
    return true;
}

export function IClaimsTeamOrganizationDtoFromJSON(json: any): IClaimsTeamOrganizationDto {
    return IClaimsTeamOrganizationDtoFromJSONTyped(json, false);
}

export function IClaimsTeamOrganizationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimsTeamOrganizationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function IClaimsTeamOrganizationDtoToJSON(json: any): IClaimsTeamOrganizationDto {
    return IClaimsTeamOrganizationDtoToJSONTyped(json, false);
}

export function IClaimsTeamOrganizationDtoToJSONTyped(value?: IClaimsTeamOrganizationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

